module.exports = __webpack_public_path__ + "img/map.ff4e6e6e.jpg";